module.exports = __webpack_public_path__ + "static/media/memorie.62457304.png";